var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelioMapPin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 203,
    viewBox: "0 0 181 203",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3852_28827)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8896 54.8881L83.9181 17.5972C87.6705 15.3772 92.3318 15.367 96.0938 17.5706L159.815 54.8963C163.491 57.0495 165.749 60.9904 165.749 65.2506V137.029C165.749 141.211 163.571 145.092 160.001 147.271L96.2815 186.165C92.4264 188.518 87.5765 188.507 83.732 186.137L20.7025 147.278C17.1583 145.093 15 141.227 15 137.064V65.2158C15 60.9743 17.2391 57.0479 20.8896 54.8881Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.3477 113.375L91.3424 111.358L101.107 130.711L97.112 132.728L87.3477 113.375Z",
    fill: "url(#paint0_linear_3852_28827)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7344 113.503L76.0906 111.674L78.2326 115.603L74.8764 117.432L72.7344 113.503Z",
    fill: "url(#paint1_linear_3852_28827)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9922 118.811L69.6122 115.204L71.7543 119.133L65.1342 122.74L62.9922 118.811Z",
    fill: "url(#paint2_linear_3852_28827)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9844 119.699L114.122 109.905L116.553 113.661L101.416 123.455L98.9844 119.699Z",
    fill: "url(#paint3_linear_3852_28827)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2578 99.9148L106.721 95.395L108.831 99.342L100.367 103.862L98.2578 99.9148Z",
    fill: "url(#paint4_linear_3852_28827)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3606 107.36C89.6416 107.36 88.9674 107.017 88.5467 106.435C88.4095 106.247 85.1547 101.736 81.8432 96.2467C77.1862 88.5261 74.9219 83.0754 74.9219 79.5905C74.9219 71.0733 81.8491 64.1455 90.3607 64.1455C98.8723 64.1455 105.8 71.0728 105.8 79.5905C105.8 83.078 103.535 88.5254 98.8782 96.2467C95.5668 101.736 92.3119 106.244 92.1747 106.435C91.7541 107.017 91.0798 107.36 90.3609 107.36H90.3606ZM90.3606 68.6209C84.3163 68.6209 79.3972 73.5404 79.3972 79.5904C79.3972 83.8237 85.5249 94.1761 90.3583 101.231C95.1912 94.1729 101.322 83.8176 101.322 79.5904C101.325 73.5402 96.4051 68.6209 90.3606 68.6209Z",
    fill: "url(#paint5_linear_3852_28827)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3616 114.864C86.8652 114.864 83.5417 114.079 81.0059 112.656C78.0643 111.003 76.4414 108.665 76.4414 106.066C76.4414 103.96 77.5632 101.943 79.6007 100.395C81.34 99.0732 83.67 98.1155 86.3401 97.6263C87.2231 97.4652 88.1211 97.847 88.6134 98.6018C89.2518 99.5773 89.8485 100.463 90.3587 101.212C90.8718 100.46 91.4655 99.5774 92.1039 98.6018C92.5962 97.85 93.4942 97.4651 94.3773 97.6263C97.0473 98.1155 99.3773 99.0702 101.117 100.395C103.154 101.946 104.276 103.96 104.276 106.066C104.276 108.662 102.656 111.003 99.7114 112.656C97.1815 114.079 93.8581 114.864 90.3618 114.864H90.3616ZM85.7315 102.352C82.593 103.229 80.9194 104.834 80.9194 106.063C80.9194 108.065 85.0423 110.389 90.3614 110.389C95.6805 110.389 99.8034 108.065 99.8034 106.066C99.8034 104.834 98.1268 103.229 94.9913 102.355C93.3743 104.777 92.2287 106.361 92.175 106.436C91.7544 107.018 91.0802 107.361 90.3612 107.361C89.6422 107.361 88.968 107.018 88.5473 106.436C88.4936 106.358 87.348 104.774 85.7311 102.352H85.7315Z",
    fill: "url(#paint6_linear_3852_28827)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M118.255 133.956H62.4669C61.8166 133.956 61.199 133.672 60.7754 133.183C60.3518 132.691 60.1608 132.04 60.2533 131.396L66.22 90.5242C66.3811 89.4233 67.3238 88.6089 68.4336 88.6089H75.3549V93.0839H70.3668L65.0535 129.48H115.666L110.353 93.0839H105.365V88.6089H112.289C113.399 88.6089 114.342 89.4233 114.503 90.5242L120.469 131.396C120.562 132.04 120.374 132.691 119.947 133.183C119.524 133.672 118.906 133.956 118.256 133.956H118.255Z",
    fill: "url(#paint7_linear_3852_28827)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3658 86.379C86.4845 86.379 83.3281 83.2226 83.3281 79.3413C83.3281 75.4601 86.4845 72.3037 90.3658 72.3037C94.247 72.3037 97.4034 75.4601 97.4034 79.3413C97.4034 83.2226 94.247 86.379 90.3658 86.379ZM90.3658 76.7789C88.9516 76.7789 87.8031 77.9274 87.8031 79.3416C87.8031 80.7557 88.9516 81.9043 90.3658 81.9043C91.7799 81.9043 92.9285 80.7557 92.9285 79.3416C92.9285 77.9304 91.7799 76.7789 90.3658 76.7789Z",
    fill: "url(#paint8_linear_3852_28827)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3852_28827",
    x: 0,
    y: 0.924805,
    width: 180.75,
    height: 201.997,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3852_28827"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3852_28827",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3852_28827",
    x1: 99.6508,
    y1: 111.759,
    x2: 85.0937,
    y2: 106.194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D3970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1529"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3852_28827",
    x1: 77.6508,
    y1: 111.782,
    x2: 72.6055,
    y2: 108.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D3970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1529"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3852_28827",
    x1: 70.8271,
    y1: 115.345,
    x2: 63.6316,
    y2: 110.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D3970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1529"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3852_28827",
    x1: 114.694,
    y1: 110.159,
    x2: 101.318,
    y2: 99.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D3970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1529"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3852_28827",
    x1: 107.712,
    y1: 95.5539,
    x2: 99.4392,
    y2: 89.4197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D3970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1529"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3852_28827",
    x1: 102.532,
    y1: 64.9563,
    x2: 70.8006,
    y2: 51.4934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D3970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1529"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3852_28827",
    x1: 101.331,
    y1: 97.9139,
    x2: 83.709,
    y2: 81.0537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D3970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1529"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3852_28827",
    x1: 114.116,
    y1: 89.4597,
    x2: 69.0808,
    y2: 53.9233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D3970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1529"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3852_28827",
    x1: 95.914,
    y1: 72.5678,
    x2: 83.2949,
    y2: 65.0748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D3970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1529"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelioMapPin);
export default __webpack_public_path__ + "static/media/helio_map_pin.71fccbb7e8d8124228ecb985dc66b03e.svg";
export { ForwardRef as ReactComponent };